// extracted by mini-css-extract-plugin
export var activeFilterButton = "_s3-c";
export var backButton = "_s3-4";
export var backIcon = "_s3-5";
export var chevronShortcut = "_s3-6";
export var container = "_s3-1";
export var editor = "_s3-8";
export var editorWrapper = "_s3-7";
export var prefix = "_s3-2";
export var searchIcon = "_s3-3";
export var suffix = "_s3-9";
export var suffixContent = "_s3-a";
export var suffixText = "_s3-b";
export var wrapper = "_s3-0";